import { memo, useCallback } from 'react';
import { Navigation } from '../components';
import Sidebar from './sidebar';

export default memo(function SideNav(props) {
  const openScreen = useCallback((screenConfig) => {
    const { screen } = screenConfig;
    Navigation.openScreen({ screen });
  }, []);

  return <Sidebar {...props} openScreen={openScreen} />;
});
